import { defineWebExtension } from '@databink/web/extension';

/**
 * This client's screen extensions, compiled into its build of the web app
 * (DATABINK_CLIENT=demo). To add one, fill a slot the core publishes with a component
 * built from the web SDK, and declare the same slot in src/index.ts, which
 * `databink client verify` checks against the core's registry; test/web.test.ts keeps the
 * two lists in step. clients/acme/web adds a tab to a record screen and a dashboard card.
 * brand/ holds the Databink icon and logo for light and dark pages, which prospects see at
 * the top of their demo.
 */
export default defineWebExtension({
  client: 'demo',
  brand: {
    icon: new URL('./brand/databink-icon-light.svg', import.meta.url).href,
    logo: new URL('./brand/databink-logo-light.svg', import.meta.url).href,
    iconDark: new URL('./brand/databink-icon-dark.svg', import.meta.url).href,
    logoDark: new URL('./brand/databink-logo-dark.svg', import.meta.url).href,
    // The icon again, turning white in a dark browser's tab bar.
    favicon: new URL('./brand/databink-favicon.svg', import.meta.url).href,
  },
  slots: {},
});
